import { Tooltip, TooltipContent, TooltipTrigger } from '@cp/src/components/TooltipV2/TooltipV2';
import Typography from '@navi/web-ui/lib/primitives/Typography/Typography';
import { getActivityColorClassMap } from '../utils';
import cx from 'classnames';

const renderSelfCallAfterBeforeBars = (contentType: string, count: number) => {
  return (
    <Tooltip placement="top" hideStrategy="referenceHidden">
      <div className="">
        <TooltipTrigger asChild>
          <div
            className={`w-[4px] h-[24px] ${
              contentType === 'before 8am' ? 'rounded-l-sm' : 'rounded-r-sm'
            }`}
            style={{
              backgroundColor: getActivityColorClassMap['callsSelfCall']
            }}
          />
        </TooltipTrigger>
      </div>
      <TooltipContent className={cx('tooltipWrapper', 'flex flex-col items-center')}>
        <Typography variant="p5" color="var(--grayscale-3)">
          Calls done
        </Typography>
        <Typography variant="p5" color="var(--grayscale-3)">
          {contentType}
        </Typography>
        <Typography variant="h5" color="var(--bg-primary)">
          {count}
        </Typography>
      </TooltipContent>
    </Tooltip>
  );
};

export default renderSelfCallAfterBeforeBars;
